import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaYoutube,
  FaInstagram,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
} from "react-icons/fa";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="footer__top">
          {/* Thông tin công ty */}
          <Col
            md={4}
            className="footer__section"
          >
            <h4 className="footer__title">CÔNG TY TNHH DESIGN24</h4>
            <p className="footer__desc">
              Mã số thuế: 1801676144 <br />
              Ngày thành lập: 20/07/2020 <br />
              Lĩnh vực: Công nghệ, Giáo dục, Thiết kế, Lập trình. <br />
              Design24 xây dựng và phát triển những sản phẩm mang lại giá trị
              cho cộng đồng.
            </p>
          </Col>

          {/* Liên kết nhanh */}
          <Col
            md={4}
            className="footer__section"
          >
            <h4 className="footer__title">Liên kết nhanh</h4>
            <ul className="footer__links">
              <li>
                <Link
                  to="/"
                  className="footer__link"
                >
                  Trang chủ
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="footer__link"
                >
                  Giới thiệu
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className="footer__link"
                >
                  Dịch vụ
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="footer__link"
                >
                  Liên hệ
                </Link>
              </li>
            </ul>
          </Col>

          {/* Liên hệ & Mạng xã hội */}
          <Col
            md={4}
            className="footer__section"
          >
            <h4 className="footer__title">Liên hệ</h4>
            <ul className="footer__contact">
              <li>
                <FaPhoneAlt />
                <a
                  href="tel:0704888009"
                  className="footer__link"
                >
                  0704.888.009
                </a>{" "}
                -
                <a
                  href="tel:0784888009"
                  className="footer__link"
                >
                  0784.888.009
                </a>
              </li>
              <li>
                <FaEnvelope />
                <a
                  href="mailto:Design24.vn@gmail.com"
                  className="footer__link"
                >
                  Design24.vn@gmail.com
                </a>
              </li>
              <li>
                <FaMapMarkerAlt /> TP.HCM: 302A Nguyễn Thượng Hiền, P.5, Q. Phú
                Nhuận
              </li>
              <li>
                <FaMapMarkerAlt /> Cần Thơ: 661F/29, KV. Bình Yên A, P. Long
                Hòa, Q. Bình Thủy
              </li>
            </ul>

            <div className="footer__socials">
              <a
                href="https://www.facebook.com/www.design24.edu.vn"
                target="_blank"
                rel="noopener noreferrer"
                className="footer__social-link"
              >
                <FaFacebookF />
              </a>
              <a
                href="https://www.youtube.com/@design2424"
                target="_blank"
                rel="noopener noreferrer"
                className="footer__social-link"
              >
                <FaYoutube />
              </a>
              <a
                href="https://www.instagram.com/reel/DMIHauFt6bX/"
                target="_blank"
                rel="noopener noreferrer"
                className="footer__social-link"
              >
                <FaInstagram />
              </a>
            </div>
          </Col>
        </Row>

        {/* Bottom */}
        <Row className="footer__bottom">
          <Col className="text-center">
            <small>
              © {new Date().getFullYear()} Design24. Tất cả quyền được bảo lưu.
            </small>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
